define(function(require, exports, module) {
    var flowtip = {
        init: function(name) {
            var self = this;
            var isHide = self.getCookie(name + "IsHideFlowTip");

            if(isHide == "yes" && isHide != null) {
            } else {
                $(".flow-tips").parent().removeClass("hide");
            }

            $(".flow-tips .close i").on("click", function() {
                $(this).parents(".floor").remove();
                self.setCookie(name + "IsHideFlowTip", "yes");
            });
        },
        getCookie: function(name) {
            var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
            if(arr=document.cookie.match(reg)){
                return unescape(arr[2]);
            } else {
                return null;
            }
        },
        setCookie: function(name,value) {
            var exp = new Date();
            exp.setHours(exp.getHours() + (24 * 30));
            document.cookie = name + "="+ escape (value) + ";expires=" + exp.toGMTString();
        }
    };
    exports.fn = flowtip;
});


// WEBPACK FOOTER //
// ./src/js/unit/flowtip/flowtip.js